// extracted by mini-css-extract-plugin
export default {"header":"PDFEditor_header__y3z1g"};